import * as React from 'react'
import Radio, { RadioProps } from '@mui/material/Radio'
import { inputBackgroundDisabled, inputBorderDisabled } from 'app/theme/themeBase'

const UncheckedIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={className}
  >
    <circle cx='12' cy='12' r='8' fill='white' />
    <circle cx='12' cy='12' r='9' stroke='currentColor' strokeWidth='2' />
  </svg>
)

const UncheckedDisabledIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={className}
  >
    <circle cx='12' cy='12' r='8' fill={inputBackgroundDisabled} />
    <circle cx='12' cy='12' r='9' stroke={inputBorderDisabled} strokeWidth='2' />
  </svg>
)

const CheckedIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={className}
  >
    <circle
      cx='12'
      cy='12'
      r='9'
      fill='white'
      stroke='currentColor'
      strokeWidth='2'
    />
    <circle cx='12' cy='12' r='5' fill='currentColor' />
  </svg>
)

const CheckedDisabledIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={className}
  >
    <circle
      cx='12'
      cy='12'
      r='9'
      fill='white'
      stroke={inputBorderDisabled}
      strokeWidth='2'
    />
    <circle cx='12' cy='12' r='5' fill={inputBorderDisabled} />
  </svg>
)

interface IconSet {
  unchecked: React.ReactNode
  checked: React.ReactNode
  uncheckedDisabled?: React.ReactNode
  checkedDisabled?: React.ReactNode
}

const defaultIcons: IconSet = {
  unchecked: <UncheckedIcon />,
  checked: <CheckedIcon />,
  uncheckedDisabled: <UncheckedDisabledIcon />,
  checkedDisabled: <CheckedDisabledIcon />
}

type Props = RadioProps & {
  icons?: Partial<IconSet>
}

const CustomRadio: React.FC<Props> = ({
  icons,
  disabled,
  icon,
  checkedIcon,
  ...rest
}) => {
  const cfg = { ...defaultIcons, ...icons }

  const customIcon = disabled === true
    ? cfg.uncheckedDisabled ?? cfg.unchecked
    : cfg.unchecked

  const customCheckedIcon = disabled === true
    ? cfg.checkedDisabled ?? cfg.checked
    : cfg.checked

  return (
    <Radio
      disableRipple
      icon={icon ?? customIcon}
      checkedIcon={checkedIcon ?? customCheckedIcon}
      disabled={disabled}
      {...rest}
    />
  )
}

export default CustomRadio
